import { Achievement } from '@/models';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgAchievedBadgeModal',
})
export default class CmgAchievedBadgeModal extends Vue {
  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.achievedBadge.visible;
  }

  get achievement(): Achievement {
    return this.$appStore.state.ui.modals.achievedBadge.args!.achievement;
  }

  get achievementDate(): string {
    return new Date(this.achievement.achievementDate).toLocaleDateString();
  }

  onClose() {
    this.$services.ui.setModalVisibility('achievedBadge', false);
  }
}
